import { defineMessages } from 'react-intl';

export default defineMessages({
    ProducerCodeCharLimit: {
        id: 'ml.edge.quoteandbind.common.directives.MLReferralAgentsDirectiveCtrl.Producer code should have between 6 and 7 characters',
        defaultMessage: 'Producer code should have between 6 and 7 characters'
    },
    ProducerCodeEligibility: {
        id: 'ml.edge.quoteandbind.common.directives.MLReferralAgentsDirectiveCtrl.Verifying producer code eligibility...',
        defaultMessage: 'Verifying producer code eligibility...'
    },
    ProducerCodeAlreadyInList: {
        id: 'ml.edge.quoteandbind.common.directives.MLReferralAgentsDirectiveCtrl.This producer code already in the list',
        defaultMessage: 'This producer code already in the list'
    }
});